import React from 'react'
import { useDispatch } from 'react-redux'
import { answerQuestionSingle } from '../../../redux/slices/questionsSlice'
import { AnswerText } from '../common'

import './styles.scss'

const MediaAnswers = ({ question, nextQuestion }) => {
	const dispatch = useDispatch()

	const onSelectAnswer = (questionId, answerIdx) => {
		dispatch(answerQuestionSingle({ questionId, answerIdx }))
		nextQuestion()
	}

	return (
		<div className="media-answers">
			<div className="media-answers__wrapper">
				{question.video ? (
					<video
						poster={`/images/questions/predictions/${question.video}.png`}
						autoPlay="autoplay"
						loop
						muted
						src={`/videos/prediction/${question.video}.mp4`}
						type="video/mp4"
						className="media-answers__wrapper__video"
						playsInline
					/>
				) : (
					<img
						src={`/images/questions/predictions/${question.id}/${question.image}.png`}
						alt={question.image}
						className="media-answers__wrapper__image"
					/>
				)}
			</div>
			{question.answers.map((answer, answerIdx) => (
				<AnswerText
					key={answer + answerIdx}
					onSelectAnswer={() => onSelectAnswer(question.id, answerIdx)}
					answer={answer}
				/>
			))}
		</div>
	)
}

export { MediaAnswers }
